import { render, staticRenderFns } from "./MailTemplateEditor.vue?vue&type=template&id=66380e18&scoped=true"
import script from "./MailTemplateEditor.vue?vue&type=script&lang=js"
export * from "./MailTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateEditor.vue?vue&type=style&index=0&id=66380e18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66380e18",
  null
  
)

export default component.exports